export default "__VITE_ASSET__BYvJJ0Bu__"